import React, { useState, useContext, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { PatentContext } from "../context/PatentContextProvider";
import { BsCalendarDateFill } from "react-icons/bs";
import { FaArrowUp } from "react-icons/fa6";
import { typeOfVoices } from "../constants/constants";

import { FaUserTie } from "react-icons/fa6";
import axios from "axios";
import data from "../data/patents.json";

// import { OpenAI } from "openai";
import Aos from "aos";
import "aos/dist/aos.css";
import Navbar from "./Navbar";
import Bot from "./ChattingBot";
import "./style/Patentdetails.css";
import PatentDescription from "./PatentDescription";
import { Footer } from "./Footer";

const PatentDetails = () => {
  const {
    selectedPatent,
    patentSelected,
    selectedFullpatent
  } = useContext(PatentContext);
  const { patentId } = useParams();

  const [showScrollButton, setShowScrollButton] = useState(false);
  const [voiceType, setVoiceType] = useState("Legal");
  const [audioPlaying, setAudioPlaying] = useState(false);
  const [textGenerated, setTextGenerated] = useState("");
  const [loading, setLoading] = useState(false);
  const [enableChat, setEnableChat] = useState(false);
  const [newPatent, setNewPatent] = useState('');
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);
  const audioRef = useRef(null);

  const dropdownRef = useRef(null);
  const dropdownMenu = useRef(null);

  //effects//
  useEffect(() => {
    patentSelected(patentId);
    //setSummary(false);
    setNewPatent(`${patentId}-${voiceType}`)
  }, [patentId]);

  useEffect(() => {
    const generateSummary = async (languageStyle) => {
      if (!selectedPatent?.claims) return;

      try {
        const getResponse = await axios.post(
          `${process.env.REACT_APP_API_PATH}/generateSummary`,
          {
            languageStyle: voiceType,
            activePatent: {
              patentNo: selectedPatent.patentId,
              abstract: selectedPatent.abstract,
              fieldOfInvention: selectedPatent.fieldOfInventor,
              claims: selectedPatent.claims,
            }
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        const summaryGenerated =
          getResponse.data.response.candidates[0]?.content?.parts[0].text
            .replace(/[^\w\s]/g, "")
            .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "")
            .replace(/[^\w\s\']|_/g, "")
            .replace(/\s{2,}/g, "");

        if (summaryGenerated) {
          setTextGenerated(summaryGenerated);
        }
      } catch (error) {
        console.log(error, "err");
      }
    };
    generateSummary(voiceType);
  }, [voiceType]);

  async function speakSummary(text) {
    setLoading(true); // Start loading
    // if (textGenerated) {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_PATH}/generateSpeech/${patentId}-${voiceType}`,
        { text: text },
        {
          headers: { "Content-Type": "application/json" },
          responseType: "arraybuffer",
        },
      );

      const blob = new Blob([response.data], { type: "audio/mpeg" });
      const url = URL.createObjectURL(blob);

      // Stop and reset previous audio if playing
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }

      // Create new audio instance
      const audio = new Audio(url);
      audioRef.current = audio;

      audio.addEventListener("play", () => setAudioPlaying(true));
      audio.addEventListener("ended", () => {
        setAudioPlaying(false);
        URL.revokeObjectURL(url); // Clean up URL object
      });

      await audio.play();
      setLoading(false);
    } catch (error) {
      console.error("Error generating speech:", error);
      setLoading(false);
    }
    // }
  }

  const stopAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    setAudioPlaying(false);
  };

  useEffect(() => {
    Aos.init({ duration: 1500 });
  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        dropdownMenu.current &&
        !dropdownRef.current.contains(event.target) &&
        !dropdownMenu.current.contains(event.target)
      ) {
        setIsDropDownOpen(false); // Close the dropdown
      }
    };

    // Attach the event listener
    document.addEventListener("mouseover", handleClickOutside);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("mouseover", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 130) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  //scrolling to top //
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setShowScrollButton(false);
  };
  //chatbot
  const openChat = () => {
    setEnableChat(true);
  };
  const closeChat = () => {
    setEnableChat(false);
  };
  //show  claims //
  const navigate = useNavigate();
  function showClaims() {
    // handlePatentClick(selectedPatent.patentId.replace(/[\s,]/g, ""));

    navigate("/claims", {
      state: {
        activePatent: selectedPatent ? selectedPatent : data?.patents[0],
      },
    });
    window.scrollTo(0, 0);
  }
  function showFullPatent() {
    navigate(`/patent-info/${patentId}`)
  }

  return (
    <>
      <Navbar
        choosenPatent={selectedPatent}
        activePatentId={patentId}
        showScrollButton={showScrollButton}
      />

      <div id="top" className="relative" data-aos="fade-up">
        <PatentDescription patent={selectedPatent} />
        <div className="relative right-0 left-0 w-[94%] px-5 mx-auto p-2 rounded-lg  bg-white lg:px-10">
          <div className="relative h-100vh w-full ">
            <div className=" grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4  gap-2 justify-between   font-semibold   my-4 sm:my-3 md:my-2 lg:my-4">
              <div className="flex  w-64 gap-4 items-center sm:justify-start lg:justify-center ">
                <span className="w-12 h-12  rounded-full text-center pl-3 pt-2.5 bg-white border border-black ">
                  <FaUserTie className="text-2xl font-extrabold " />
                </span>
                <div>
                  <p className="text-2xl">Inventor</p>
                  <p className="text-[0.8rem] text-[#3b4455]">
                    {selectedPatent?.inventor}
                  </p>
                </div>
              </div>

              <div className="flex  w-64 gap-4 items-center  sm:justify-start lg:justify-center ">
                <span className="w-12 h-12  rounded-full text-center pl-2 pt-2.5 bg-white border border-black ">
                  <svg
                    class="w-7 h-7"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                  >
                    <path d="M0 96l576 0c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96zm0 32V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128H0zM64 405.3c0-29.5 23.9-53.3 53.3-53.3H234.7c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7H74.7c-5.9 0-10.7-4.8-10.7-10.7zM176 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm176 16c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16z"></path>
                  </svg>
                </span>
                <div>
                  <p className="text-2xl">Patent ID</p>
                  <p className="tex5t-[0.8rem] text-[#3b4455]">
                    {selectedPatent?.patentId}
                  </p>
                </div>
              </div>

              <div className="flex  w-64 gap-4  items-center sm:py-2 sm:justify-start lg:justify-center ">
                <span className="w-12 h-12  rounded-full text-center pl-3 pt-2.5 bg-white border border-black ">
                  <BsCalendarDateFill className="text-2xl font-extrabold " />
                </span>
                <div>
                  <p className="text-2xl">File Date</p>
                  <p className="text-[0.8rem] text-[#3b4455]">
                    {selectedPatent?.fileDate}
                  </p>
                </div>
              </div>
              <div className="flex  w-64 gap-4  items-center sm:py-2 sm:justify-start lg:justify-center ">
                <span className="w-12 h-12  rounded-full text-center pl-3 pt-2.5 bg-white border border-black ">
                  <BsCalendarDateFill className="text-2xl font-extrabold " />
                </span>
                <div>
                  <p className="text-2xl">Issued Date</p>
                  <p className="text-[0.8rem] text-[#3b4455]">
                    {selectedPatent?.issued}
                  </p>
                </div>
              </div>
            </div>
            <div className="pb-4">
              <p className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-semibold leading-3 text-[#00A4E5] pt-4 pb-8 font-openfont  text-start">
                Abstract
              </p>
              <div className="relative group">
                <button className="min-w-[225px] md:min-w-[280px] lg:min-w-[302px] md:px-5 py-2 fixed  md:top-[22.5rem] md:right-10 lg:top-[28.5rem] 2xl:right-[7rem] lg:right-14 right-4 px-2  text-sm  top-[21rem] justify-center items-center  bg-[#00A4E5] hover:bg-blue-400  font-semibold flex text-md lg:text-lg mt-[-15px] text-white">
                  Summary Style ( {voiceType} )
                  <svg
                    class="w-2.5 h-2.5 ms-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 10 6"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m1 1 4 4 4-4"
                    />
                  </svg>
                  <ul className="absolute right-0 md:w-[17.5rem] top-8 w-[14.1rem] lg:top-11 hidden lg:w-[19rem] bg-white  group-hover:block  border border-gray-200 divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                    {typeOfVoices
                      .filter((item) => item !== voiceType)
                      .map((val) => (
                        <li
                          className="block px-4 py-2 text-sm text-[#5c636e]  font-bold hover:bg-gray-600 hover:text-white"
                          onClick={() => setVoiceType(val)}
                        >
                          {val}
                        </li>
                      ))}
                  </ul>
                </button>
              </div>
              <p className="text-md sm:text-lg leading-relaxed text-[#3b4455] text-[12px] font-roboto">
                {selectedPatent?.abstract}
              </p>
              <p className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-semibold leading-3 text-[#00A4E5] py-8 font-openfont">
                Field Of Inventor
              </p>
              <p className="text-md sm:text-lg leading-relaxed text-[#3b4455] text-[12px] font-roboto">
                {selectedPatent.fieldOfInventor}
              </p>
              <div className="flex  pt-5 gap-4 items-center justify-center">
                <button
                  className="bg-[#00A4E5] px-7 py-3 rounded-lg text-white font-semibold"
                  onClick={showClaims}
                >
                  View {selectedPatent?.claims?.length + " "}Claims
                </button>
                <button
                  className="bg-[#00A4E5] px-7 py-3 rounded-lg text-white font-semibold"
                  onClick={showFullPatent}
                >
                  Click for Full Patent
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="  w-full">
        {showScrollButton && (
          <button
            className="fixed bottom-5  py-2 px-2 right-7 sm:py-2 sm-px-2 md:right-11 md:bottom-2 md:px-3 md:py-3 md:text-2xl  text-xl z-10 cursor-pointer hover:bg-[#5f6769] bg-[#393e46] text-white rounded-full lg:bottom-2 lg:right-11 "
            onClick={scrollToTop}
          >
            <FaArrowUp />
          </button>
        )}
      </div>
      <button className="flex items-center justify-center md:w-16 md:h-16  fixed bottom-[120px] right-4  py-2 px-2 sm:right-5 sm:py-2 sm-px-2 md:right-7 md:bottom-20 md:px-3 md:py-3 md:text-2xl  text-xl z-10 cursor-pointer hover:bg-[#5f6769] bg-[#393e46] text-white rounded-full lg:bottom-36 lg:right-10">
        {loading ? (
          <span class=" w-6 h-6 border-2 border-t-transparent border-white rounded-full inline-block animate-spin mr-2"></span>
        ) : audioPlaying ? (
          <svg
            class=" w-5 h-5 md:w-8 md:h-8"
            onClick={stopAudio}
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 384 512"
          >
            <path d="M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"></path>
          </svg>
        ) : (
          <svg
            onClick={() => speakSummary(textGenerated)}
            class="w-5 h-5 md:w-8 md:h-8 "
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 384 512"
          >
            <path d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"></path>
          </svg>
        )}
      </button>
      {enableChat && <Bot closeChat={closeChat} />}
      <button
        className="fixed bottom-20 right-7  py-2 px-2 sm:right-5 sm:py-2 sm-px-2 md:right-10 md:bottom-7 md:px-3 md:py-3 md:text-2xl  text-xl z-10 cursor-pointer hover:bg-[#5f6769] bg-[#393e46] text-white rounded-full lg:bottom-16"
        onClick={openChat}
      >
        <svg
          class="w-5 h-5 md:w-8 md:h-8"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"></path>
          <path d="M8 12h.01"></path>
          <path d="M12 12h.01"></path>
          <path d="M16 12h.01"></path>
        </svg>
      </button>
      <Footer />
    </>
  );
};

export default PatentDetails;
